import { keyframes } from '../../lib/stitches'

export const appear = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
})
